import React from 'react';
import { connect } from 'react-redux';
import { Switch, Route, withRouter, Redirect, Link } from 'react-router-dom';
import _ from 'lodash';
import PropTypes from 'prop-types';
import { getJson } from 'session';
import { Acl } from 'modules/common/components/Acl';
// import AssistancesContainer from './categories/container/CategoryContainer';
import CategoryContainer from './categories/container/CategoryContainer';

function SingleParentSettingsTabContainer({ match, pathName, permissions }) {
  return (
    <React.Fragment>
      <div className="container-fluid">
        <div className="row border-bottom-row">
          <ul className="nav nav-tabs sub-tab-borongan">
            {Acl(permissions, ['VIEW SINGLE PARENT CATEGORIES SETTINGS']) && (
              <li className="nav-item">
                <Link
                  to="/social-ameliorations/settings/single-parent"
                  className={`nav-link sub-tab py-3 px-5 ${pathName.indexOf(
                    '/social-ameliorations/settings/single-parent/categories'
                  ) > -1
                    ? 'selected'
                    : ''
                    }`}
                >
                  Categories
                </Link>
              </li>
            )}
            {/* {Acl(permissions, ['VIEW SINGLE PARENT ASSISTANCES SETTINGS']) && (
              <li className="nav-item">
                <Link
                  to="/single-parent/settings/assistances"
                  className={`nav-link sub-tab py-3 px-5 ${pathName.indexOf(
                    '/single-parent/settings/assistances'
                  ) > -1
                    ? 'selected'
                    : ''
                    }`}
                >
                  Assistances
                </Link>
              </li>
            )} */}
          </ul>
        </div>
      </div>
      <Switch>
        <Route
          exact
          path={`${match.path}`}
          render={() => <Redirect to={`${match.path}/categories`} />}
        />
        {Acl(permissions, ['VIEW SINGLE PARENT CATEGORIES SETTINGS']) && (
          <Route
            path={`${match.path}/categories`}
            component={CategoryContainer}
          />
        )}
        {/* {Acl(permissions, ['VIEW SINGLE PARENT ASSISTANCES SETTINGS']) && (
          <Route
            path={`${match.path}/assistances`}
            component={AssistanceContainer}
          />
        )} */}
      </Switch>
    </React.Fragment>
  );
}

SingleParentSettingsTabContainer.propTypes = {
  match: PropTypes.instanceOf(Object).isRequired,
  pathName: PropTypes.string.isRequired,
  permissions: PropTypes.instanceOf(Object).isRequired,
};

const mapStateToProps = ({ api }, { match, location }) => ({
  mainModule: _.get(match, 'params.mainModule'),
  pathName: _.get(location, 'pathname'),
  profile: _.get(api, 'AUTH/user_profile.item') || {},
  permissions: getJson('permissions'),
});

const enhance = _.flowRight([withRouter, connect(mapStateToProps)]);

export default enhance(SingleParentSettingsTabContainer);
